import { useForm } from "react-hook-form";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface University {
  id: number;
  name: string;
  campaign_start_date: string;
  campaign_end_date: string;
}

interface UniversityFormProps {
  university: University | null;
  onSubmit: (data: Omit<University, 'id'>) => Promise<void>;
  onClose: () => void;
}

export function UniversityForm({ university, onSubmit, onClose }: UniversityFormProps) {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      name: university?.name || "",
      campaign_start_date: university?.campaign_start_date ? new Date(university.campaign_start_date).toISOString().split('T')[0] : "",
      campaign_end_date: university?.campaign_end_date ? new Date(university.campaign_end_date).toISOString().split('T')[0] : "",
    },
  });

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          {university ? "Edit University" : "Add University"}
        </DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="name">University Name</Label>
          <Input
            id="name"
            {...register("name", { required: true })}
            placeholder="Enter university name"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="campaign_start_date">Campaign Start Date</Label>
          <Input
            id="campaign_start_date"
            type="date"
            {...register("campaign_start_date", { required: true })}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="campaign_end_date">Campaign End Date</Label>
          <Input
            id="campaign_end_date"
            type="date"
            {...register("campaign_end_date", { required: true })}
          />
        </div>

        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit">
            {university ? "Update" : "Add"} University
          </Button>
        </div>
      </form>
    </DialogContent>
  );
}